// TODO: Refactor file to jibe with the graphql/template-strings lint rule
import gql from 'graphql-tag';

export const GET_CATEGORY_PAGE = gql`
  query CmsCategoryPage($id: String!) {
    cms {
      page(id: $id) {
        description
        documentTitle
        metaTags {
          name
          content
        }
      }
    }
  }
`;

const categoryData = gql`
  fragment categoryData on CategoryData {
    packageImage {
      altText
      format
      width
      galleryIndex
      imageType
      url
    }
    thumbnail {
      altText
      imageType
      url
    }
    code
    catalogURL
    description
    url
    seoName
    name
    superCategories {
      name
      url
    }
  }
`;

export const GET_CATEGORY_BY_SEO_NAME = gql`
  query CategoryBySeoName($seoName: String!) {
    categoryBySeoName(seoName: $seoName) {
      ...categoryData
    }
  }

  ${categoryData}
`;

export const GET_BRAND_CATEGORIES_BY_SEO_NAME = gql`
  query BrandCategoryQueries(
    $onlyThatFits: Boolean!
    $seoName: String!
    $productType: ProductTypeEnum!
    $storeCode: String!
    $vehicleInfo: VehicleInput
  ) {
    brandCategory {
      bySeoName(
        onlyThatFits: $onlyThatFits
        seoName: $seoName
        productType: $productType
        storeCode: $storeCode
        vehicleInfo: $vehicleInfo
      ) {
        ...categoryData
      }
    }
  }
  ${categoryData}
`;

export const GET_TAXONOMY_CATEGORIES = gql`
  query TaxonomyCategories(
    $onlyThatFits: Boolean!
    $taxonomySeoName: String!
    $storeCode: String!
    $vehicleInfo: VehicleInput
  ) {
    taxonomyCategory {
      bySeoName(
        onlyThatFits: $onlyThatFits
        taxonomySeoName: $taxonomySeoName
        storeCode: $storeCode
        vehicleInfo: $vehicleInfo
      ) {
        ...categoryData
      }
    }
  }
  ${categoryData}
`;

export const GET_PRODUCTS_BY_BRAND_AND_CATEGORIES = gql`
  query ProductsByBrandAndCategories(
    $categorySeoName: String!
    $storeCode: String!
    $vehicleInfo: VehicleInput
  ) {
    productSearch {
      byCategory(
        page: 0
        categorySeoName: $categorySeoName
        sortCode: "RELEVANCE"
        storeCode: $storeCode
        vehicleInfo: $vehicleInfo
      ) {
        results {
          articleStatus
          articleStatusLabel
          code
          images {
            altText
            format
            imageType
            url
          }
          line
          name
          potentialPromotions {
            code
          }
          url
          swatches {
            code
            color
          }
        }
      }
    }
  }
`;

export const GET_BUNDLE_CATEGORIES = gql`
  query BundleCategories($vehicleInfo: VehicleInput!, $storeCode: String!) {
    taxonomyCategory {
      bundleCategories(vehicleInfo: $vehicleInfo, storeCode: $storeCode) {
        ...categoryData
      }
    }
  }
  ${categoryData}
`;
